import { inject, Injectable, signal } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { environment } from "src/environments/environment";
import { HttpClient } from '@angular/common/http';
import { RestService } from 'src/app/services/rest.service';
import { AuthService } from 'src/app/auth/services';
import { PopUp, BottomSheet, BadgePayload } from '../interfaces';
import { AddedBadge } from '../interfaces/badge.interface';
import { Snackbar } from 'src/app/services';

@Injectable({ providedIn: 'root' })
export class GamificationService {  
  // Service injections
  private _authService = inject(AuthService);
  private _rest = inject(RestService);
  private _http = inject(HttpClient);
  private _snackbarService = inject(Snackbar);
  
  // Service signal state
  private _passportsEnabled = signal<boolean>(false);
  public passportsEnabled = this._passportsEnabled.asReadonly();

  private _passportPopup = signal<PopUp | null>(null);
  public passportPopup = this._passportPopup.asReadonly();
  
  private _addedBadge = signal<AddedBadge | null>(null);
  public addedBadge = this._addedBadge.asReadonly();

  private _passportBottomSheet = signal<BottomSheet | null>(null);
  public passportBottomSheet = this._passportBottomSheet.asReadonly();

  // Local variables
  private apiUrlBase: string = environment.apiUrlBase;
  
  // Setters for service signals
  public setPassportsEnabled(){
    this._passportsEnabled.set(true);
  }

  public setPassportPopup(popup: PopUp){
    this._passportPopup.set(popup);
  }
  
  public setAddedBadge(badge: AddedBadge | null){
    this._addedBadge.set(badge);
  }

  public setPassportBottomSheet(bottomSheet: BottomSheet){
    this._passportBottomSheet.set(bottomSheet);
  }
  
  // Methods
  public sealBadgeByQrCodeServiceSignal(qrCode: string) {
    return this._sealByQrCode(qrCode)
      .subscribe({
        next: (res: AddedBadge) => {
          this.setAddedBadge(res);
        },
        error: (error) => {
          this._snackbarService.showErrorSnackbar(error.message);
        }
      })
  }

  private _sealByQrCode(qrCode: string){
    const payload: Partial<BadgePayload> = {
      webuser_id: this._authService.user()?.id,
      qr_code: qrCode
    };
    
    if (this._rest.device.client) {
      payload.client_id = this._rest.device.client;
    } else if (this._rest.device.distributorID) {
      payload.distributor_id = this._rest.device.distributorID;
    }

    return this._http.post(`${this.apiUrlBase}/api/gamification/badges/seal`, payload).pipe(
      catchError((err) => {
        return throwError(() => new Error(`Error sealing badge`, { cause: err }));
      })
    );
  }
}